/* global axios */
import ApiClient from '../ApiClient';

class InstagramChannel extends ApiClient {
  constructor() {
    super('instagram', { accountScoped: true });
  }

  // Para reautorização - mesma rota, mas com inbox_id
  reauthorizeInstagram({ inboxId, instagramId, accessToken }) {
    return axios.post(`${this.baseUrl()}/instagram/authorization`, {
      inbox_id: inboxId,
      instagram_id: instagramId,
      access_token: accessToken,
    });
  }

  // Para criação inicial (mantém a lógica OAuth)
  createAuthorization() {
    return axios.post(`${this.baseUrl()}/instagram/authorization`);
  }
}

export default new InstagramChannel();